import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import Info, { InfoTypes } from '@zvuk-b2b/react-uikit/ui/Info';

import { LicensesModalHintProps } from './licensesModalHintProps';

import styles from './LicensesModalHint.module.scss';

const LicensesModalHint: FC<LicensesModalHintProps> = ({
  isOneLicense,
  isPendingAcceptanceAdvanced,
  hasSberConnection,
  withResidualPayment,
  licensesSubscriptionCost,
  formatNextBillingDate,
}) => {
  if (isPendingAcceptanceAdvanced) {
    return (
      <Info
        type={InfoTypes.WARNING}
        className={styles.licensesModalHintInfo}>
        {!hasSberConnection
          ? TEXTS.BILLING_LICENSES_NO_SBER_CONNECTION_TEXT
          : TEXTS.BILLING_LICENSES_ACCEPTANCE_ADVANCED_PENDING}
      </Info>
    );
  }

  return (
    <Info className={styles.licensesModalHintInfo}>
      {withResidualPayment ? (
        <div className={styles.licensesModalHintInfoResidual}>
          <div>{TEXTS.BILLING_LICENSES_UNPAID_MODAL_RESIDUAL_INFO(isOneLicense)}</div>
          <div>
            <div>{TEXTS.BILLING_LICENSES_UNPAID_MODAL_RESIDUAL_DESCRIPTION}</div>
            <div>
              {TEXTS.BILLING_LICENSES_UNPAID_MODAL_RESIDUAL_PRICE(licensesSubscriptionCost, formatNextBillingDate)}
            </div>
          </div>
        </div>
      ) : (
        TEXTS.BILLING_LICENSES_UNPAID_MODAL_INFO(isOneLicense)
      )}
    </Info>
  );
};

export default React.memo(LicensesModalHint);
